module.exports = __webpack_public_path__ + "media/images/share-fb-04efde1a4d92db766674e0edc8276faa.svg";